import { render, staticRenderFns } from "./TestRouter.vue?vue&type=template&id=0e0285fb&scoped=true"
import script from "./TestRouter.vue?vue&type=script&lang=js"
export * from "./TestRouter.vue?vue&type=script&lang=js"
import style0 from "./TestRouter.vue?vue&type=style&index=0&id=0e0285fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0285fb",
  null
  
)

export default component.exports